import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

export default function KPIs() {
  const [kpi, setKpi] = useState(null);
  const [int, setInt] = useState(null);

  async function load() {
    const [k, i] = await Promise.all([api.kpi(), api.integrationStats()]);
    setKpi(k); setInt(i);
  }
  useEffect(() => { load().catch(console.error); }, []);

  if (!kpi) return <div className="text-slate-500">Loading...</div>;

  const chartData = kpi.hourly.map(h => ({
    t: new Date(h.bucket).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    received: h.prescriptions_received,
    filled: h.prescriptions_filled,
    rejected: h.prescriptions_rejected,
    fill_rate: Number(h.fill_rate_pct || 0),
    avg_fill: Number(h.avg_fill_minutes || 0),
  }));

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">KPIs & Analytics</h1>

      <div className="card p-4">
        <h2 className="font-semibold mb-3">Prescription Flow — Last 24 Hours</h2>
        <div className="h-64">
          <ResponsiveContainer>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="t" fontSize={11} />
              <YAxis fontSize={11} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="received" stroke="#3b82f6" name="Received" />
              <Line type="monotone" dataKey="filled"   stroke="#10b981" name="Filled" />
              <Line type="monotone" dataKey="rejected" stroke="#ef4444" name="Rejected" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-4">
          <h2 className="font-semibold mb-3">Fill Rate %</h2>
          <div className="h-56">
            <ResponsiveContainer>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="t" fontSize={11} /><YAxis fontSize={11} domain={[0,100]} />
                <Tooltip /><Bar dataKey="fill_rate" fill="#10b981" name="%" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="card p-4">
          <h2 className="font-semibold mb-3">Avg Fill Time (min)</h2>
          <div className="h-56">
            <ResponsiveContainer>
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="t" fontSize={11} /><YAxis fontSize={11} />
                <Tooltip /><Bar dataKey="avg_fill" fill="#f59e0b" name="min" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card p-4">
          <h2 className="font-semibold mb-3">Bottlenecks (Rx in-flight)</h2>
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 text-left">
              <tr><th>Status</th><th>Count</th><th>Avg wait (min)</th></tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {kpi.bottlenecks.map(b => (
                <tr key={b.status}>
                  <td className="py-2"><span className="badge-neutral">{b.status}</span></td>
                  <td>{b.n}</td>
                  <td>{b.avg_wait_min}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="card p-4">
          <h2 className="font-semibold mb-3">Integration Health (24h)</h2>
          <ul className="text-sm space-y-2">
            {int?.last_24h?.map((r, i) => (
              <li key={i} className="flex justify-between border-b border-slate-100 pb-1">
                <span>{r.protocol} / {r.direction}</span>
                <span>
                  <span className="badge-neutral mr-1">{r.status}</span>
                  <span className="font-mono">{r.n}</span>
                </span>
              </li>
            ))}
            {(!int || !int.last_24h?.length) && <li className="text-slate-400">No messages in last 24h</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
